export const iconFontAwesomeMedicalHealthBriefcaseMedical = (
	<i className="fa-solid fa-briefcase-medical"></i>
);
